module.exports = __webpack_public_path__ + "static/media/mobile.2eee4050.svg";